import { render, staticRenderFns } from "./Paysuccess.vue?vue&type=template&id=97418d0a&scoped=true"
import script from "./Paysuccess.vue?vue&type=script&lang=js"
export * from "./Paysuccess.vue?vue&type=script&lang=js"
import style0 from "./Paysuccess.vue?vue&type=style&index=0&id=97418d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97418d0a",
  null
  
)

export default component.exports